import { Record } from 'immutable';

import { SubscriptionListEntity } from '../components/depot-creation-modal/available-subscriptions-list.entity';

export const DepotConfigSliceKey = 'config';

export interface IDepotCreationSliceState {
	loading: boolean;
	subscriptionsForDepotCreation: SubscriptionListEntity | null;
}

const defaults: IDepotCreationSliceState = {
	loading: false,
	subscriptionsForDepotCreation: null,
};

export class DepotConfigSliceState extends Record<IDepotCreationSliceState>(
	defaults
) {
	public static readonly key = DepotConfigSliceKey;

	public setLoading(isLoading: boolean): DepotConfigSliceState {
		return this.set('loading', isLoading);
	}

	public setAvailableSubscriptions(
		subs: SubscriptionListEntity
	): DepotConfigSliceState {
		return this.set('subscriptionsForDepotCreation', subs);
	}
}
